import { render } from "./KycFailure.vue?vue&type=template&id=7ab29837&scoped=true"
import script from "./KycFailure.vue?vue&type=script&lang=js"
export * from "./KycFailure.vue?vue&type=script&lang=js"

import "./KycFailure.vue?vue&type=style&index=0&id=7ab29837&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab29837"]])

export default __exports__